<ng-container *transloco="let t"
  ><h3>
    {{ t('driver-analysis-dialog.hierarchy-step.select-questions') }}
  </h3>

  <h3>{{ t('driver-analysis-dialog.hierarchy-step.choose-question') }}</h3>

  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="hierarchy-step__scroll-container">
    @if (!isLoading && !availableHierarchyFields?.length) {
      <p>
        {{ t('driver-analysis-dialog.hierarchy-step.no-less-than') }}
      </p>
    }
    @for (field of availableHierarchyFields; track field) {
      <div class="analysis-target-step__hierarchy-row">
        <xi-radio
          [label]="field.label"
          [value]="field.value"
          [(ngModel)]="data.breakdownColumn"
          (onChange)="onValidityChange.emit(true)"
          name="hierarchy"
        >
        </xi-radio>
      </div>
    }
  </div>
</ng-container>
